"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommentsController = function CommentsController(Util, Report, growl, $state, $uibModal) {
    "ngInject";

    (0, _classCallCheck3.default)(this, CommentsController);
    var vm = this;
    vm.comments = [];
    vm.reportFilter = "all"; // mostra commenti e segnalazioni insieme
    vm.$onInit = start;
    vm.addNote = addNote;
    vm.markAsRead = markAsRead;
    vm.markAsUnread = markAsUnread;
    vm.saveNote = saveNote;
    vm.goToResource = goToResource;
    vm.next = next;
    vm.prev = prev;
    vm.viewImages = viewImages;
    vm.pagination = {
        page: 0,
        offset: 25
    };
    vm.newNotes = [];
    vm.showNewNotes = [];
    vm.changeReportFilter = start;
    vm.viewReportMap = viewReportMap;

    function start() {
        vm.pagination.page = 0;
        init();
    }

    function init() {
        vm.newNotes = [];
        vm.showNewNotes = [];

        Report.getList(vm.pagination.page, vm.pagination.offset, vm.reportFilter).then(function (res) {
            vm.comments = res.data;
        });
    }

    function addNote(report, reportIndex) {
        // console.log("Add note", report);
        vm.showNewNotes[reportIndex] = true;
    }

    function saveNote(report, reportIndex) {
        if (!vm.newNotes[reportIndex]) {
            vm.showNewNotes[reportIndex] = false;
            return false;
        }
        var adminComment = {
            comment: vm.newNotes[reportIndex],
            createdDate: new Date(),
            report: { id: report.id }
        };
        Report.postAdminComment(adminComment).then(function (res) {
            init();
            vm.newNotes[reportIndex] = "";
            vm.showNewNotes[reportIndex] = true; // continua a mostrare i commenti
            growl.success("Nota interna aggiunta correttamente");
        }, function (err) {
            growl.error("Error salvataggio nota interna");
        });
    }

    function markAsRead(report, reportIndex) {
        var callback = function callback() {
            growl.success("Segnalazione segnata come letta");
            report.reportStatus = "READ";
        };
        changeReportStatus(report, callback);
    }

    function markAsUnread(report, reportIndex) {
        var callback = function callback(rep) {
            growl.success("Segnalazione segnata come non letta");
            rep.reportStatus = "UNREAD";
        };
        changeReportStatus(report, callback);
    }

    function changeReportStatus(report, callback) {
        var reportCopy = angular.copy(report);
        Report.put(reportCopy).then(function (res) {
            callback(report);
        }, function (err) {
            growl.error("Errore cambio stato segnalazione");
        });
    }

    function goToResource(report) {
        $state.go("dashboard.detail.description", {
            id: report.modelId,
            modelType: report.modelEnum,
            modelName: report.modelEnum
        });
    }

    function next() {
        if (vm.comments.length < vm.pagination.offset) {
            return;
        }
        vm.pagination.page++;
        init();
    }

    function prev() {
        if (vm.pagination.page === 0) {
            return;
        }
        vm.pagination.page--;
        init();
    }

    function viewImages(report, reportIndex) {
        return $uibModal.open({
            component: 'reportImages',
            size: 'lg',
            resolve: {
                images: function images() {
                    return report.images;
                }
            }
        });
    }

    function viewReportMap(_report, reportIndex) {
        return $uibModal.open({
            component: 'reportMap',
            size: 'lg',
            resolve: {
                report: function report() {
                    return _report;
                }
            }
        });
    }
};

exports.default = CommentsController;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/comments/comments.controller.js